module.exports = __webpack_public_path__ + "img/dbg6.58a93605.jpg";